// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"413":"db053bbb","572":"ca1735b4","720":"b65787f0"}[chunkId] + ".css";
};